<div class="relative" [class.ig-iti-search-attr-map-light]="style==='light'">
  <div class="px-2 h-[3.5vh] flex justify-between items-center rounded-3xl bg-[#1d1d1df0]"
    [class.!bg-[#fffffff0]]="style==='light'" [class.border-gray-400]="style==='light'"
    [class.border]="style==='light'">
    <input type="text" class="border-none outline-0 h-full w-full text-white px-3 bg-transparent"
      [placeholder]="placeholder" matInput [formControl]="searchControl" [class.!text-gray-600]="style==='light'"
      (focus)="onInputFocus($event)">
    <mat-icon class="!h-5 text-[20px] text-gray-400 cursor-pointer" (click)="iconClick($event)">{{ searchControl.value ?
      'clear' : 'search' }}
    </mat-icon>
  </div>

  <div [class.hidden]="!items.length || isLoading || isHide" igOutsideClick (outsideClick)="isHide = true" class="absolute top-[4vh] left-0 w-[calc(100%-4px)] mx-0.5 transition-all duration-700 z-20 bg-[#1d1d1df0]
      rounded-lg flex flex-col gap-3 py-3 max-h-[50vh] overflow-auto ig-search-attr-result"
    [class.!bg-[#fffffff0]]="style==='light'" [class.border-gray-400]="style==='light'" [class.border]="style==='light'"
    igClickStopPropagation>
    @if (searchFor === 'all') {
    <p *ngIf="getPlaces().length" class="!mx-3 my-1 pb-2.5 border-b-2 border-dashed border-gray-300 text-gray-500">
      Places</p>
    <ng-container *ngTemplateOutlet="myReusableTemplate; context: { $implicit: getPlaces() }"></ng-container>

    <p *ngIf="getEvents().length" class="!mx-3 my-1 pb-2.5 border-b-2 border-dashed border-gray-300 text-gray-500">
      Events</p>
    <ng-container *ngTemplateOutlet="myReusableTemplate; context: { $implicit: getEvents() }"></ng-container>
    } @else {
    <ng-container *ngTemplateOutlet="myReusableTemplate; context: { $implicit: items }"></ng-container>
    }

  </div>

  <div
    class="absolute hidden top-[4vh] left-0 w-[calc(100%-4px)] mx-0.5 transition-all duration-700 z-20 bg-[#1d1d1df0] rounded-lg flex-col gap-3 p-3"
    [class.!flex]="!items.length && !isLoading && !isHide" [class.!bg-[#fffffff0]]="style==='light'"
    [class.border-gray-400]="style==='light'" [class.border]="style==='light'">
    <p [class.text-gray-600]="style==='light'">No items found.</p>
  </div>

  <div
    class="absolute hidden top-[4vh] left-0 w-[calc(100%-4px)] mx-0.5 transition-all duration-700 z-20 bg-[#1d1d1df0] rounded-lg flex-col gap-3 p-3"
    [class.!flex]="isLoading" [class.!bg-[#fffffff0]]="style==='light'" [class.border-gray-400]="style==='light'"
    [class.border]="style==='light'">
    <p [class.text-gray-600]="style==='light'">Searching items...</p>
  </div>

  <ng-template #myReusableTemplate let-data>
    <div *ngFor="let item of data; let i = index"
      class="ig-iti-search-attr-item px-6 py-1 cursor-pointer relative flex gap-2 justify-between items-center hover:bg-[#000000eb]"
      igClickStopPropagation (click)="add(item, i)">
      <div>
        <p class="text-[deepskyblue]">{{ item.name }}</p>
        <div class="text-xs flex gap-4 items-center">
          <span [class.text-gray-600]="style==='light'">{{ item['categoryText'] || item['timeOneLine'] }}
            <span *ngIf="item.rating" class="whitespace-nowrap">
              <mat-icon class="!w-3 !h-3 ml-2">star</mat-icon>
              {{ item.rating }}
            </span>
          </span>
        </div>
      </div>
      <div>
        <mat-icon *ngIf="!isItemAdded(item, i)" class="text-[#ffffff91] text-[22px] !h-[22px]"
          matTooltip="Add to itinerary" (click)="add(item, i)" igClickStopPropagation>
          add_circle
        </mat-icon>

        <div *ngIf="isItemAdded(item, i)" class="flex gap-1 items-center">
          <ig-success-checkmark [width]="20"></ig-success-checkmark>
          <span class="text-[11px]" [class.text-gray-600]="style==='light'">Added</span>
        </div>
      </div>
    </div>
  </ng-template>

</div>